var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPreviousDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Components",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#73818E",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.000000, 10.000000)",
    fill: "#FFFFFF",
    id: "Icons-/-Global-/-Arrow"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.000000, 10.000000) scale(-1, 1) translate(-10.000000, -10.000000) "
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,0 L8.565,1.393 L16.172,9 L0,9 L0,11 L16.172,11 L8.586,18.586 L10,20 C13.661,16.339 16.496,13.504 20,10 L10,0",
    id: "arrow_right-[#349]"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviousDark);
export default __webpack_public_path__ + "static/media/previous-dark.f159b56f.svg";
export { ForwardRef as ReactComponent };